import("pixi.js");
declare global {
    /* eslint-disable no-unused-vars */
    interface Window {
        PIXI: any;
    }
}
import * as PIXI from "pixi.js";

/* eslint-disable no-undef */
window.PIXI = PIXI;
require("pixi-spine");
require("pixi-particles");

import { gsap } from "gsap";
import { CustomEase } from "gsap/dist/CustomEase";
import { CustomWiggle } from "gsap/dist/CustomWiggle";
import { PixiPlugin } from "gsap/dist/PixiPlugin";

PixiPlugin.registerPIXI(PIXI);
gsap.registerPlugin(CustomEase, CustomWiggle, PixiPlugin);

import { NolimitSlotAudio } from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import { SlotKeypad } from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import { NolimitLauncher } from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import { NolimitGameIntroPlugin } from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import { LogLevel } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { DDD } from "./game/DDD";
import { NolimitPromotionPlugin } from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import { DDDIntroConfig } from "./game/config/DDDIntroConfig";
import { DDDPromoPanelConfig } from "./game/config/DDDPromoPanelConfig";

declare global {
    interface Window {
        NolimitLauncher: NolimitLauncher;
    }
}

window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.settings.log = LogLevel.DEV;
NolimitLauncher.instance.launch([
    new DDD(),
    new SlotKeypad(),
    new NolimitGameIntroPlugin(new DDDIntroConfig()),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new DDDPromoPanelConfig()),
]);
